import client from '../lib/http-client';

const endpoint = '/statistics';

export default {
	// Get
	getStatistics(cb, errorCb) {
		const url = `${endpoint}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url)
			.then(responseHandler)
			.catch(errorHandler);
	},
};
